<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("activities.title") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $t("activities.title") }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2">
          <base-button
            :outline="true"
            :icon="filterIcon"
            size="large"
            color="theme"
            right-icon
            @click="toggleFilter"
          >
            {{ $t("general.filter") }}
          </base-button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-show="showFilters" class="filter-section">
        <div class="row">
          <div class="col-sm-3">
            <label class="form-label">{{ $t("general.from") }}</label>
            <base-date-picker
              v-model="from_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label">{{ $t("general.to") }}</label>
            <base-date-picker
              v-model="to_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label">{{ $t("general.select_account") }}</label>
            <base-select
              v-model="selectedAccount"
              :options="accountOption"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('dashboard.select_account')"
              group-values="options"
              group-label="label"
              track-by="id"
              label="company_name"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label">{{
              $t("general.select_activity")
            }}</label>
            <base-select
              v-model="selectedActivity"
              :options="activityOption"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_activity')"
            />
          </div>
          <label class="clear-filter" @click="clearFilter">{{
            $t("general.clear_all")
          }}</label>
        </div>
      </div>
    </transition>
    <div class="row">
      <div class="col-lg-12 mt-5">
        <div class="card dashboard-card">
          <div class="graph-body" v-if="updateChart && isLoaded">
            <div class="card-body col-md-12 col-lg-12 col-xl-10">
              <bar-chart
                v-if="updateChart && isLoaded"
                :label="selected_user_type"
                :labels="chartData.labels"
                :values="chartData.values"
                :backgroundColor="chartData.colors"
                :borderColor="chartData.colors"
                :hoverBackgroundColor="chartData.colors"
                :hoverBorderColor="chartData.colors"
                :updateChart="updateChart"
              />
            </div>
            <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
              <div class="stats" v-if="updateChart && isLoaded">
                <div
                  class="description"
                  v-for="info in chartData.info"
                  v-bind:key="info.label"
                >
                  <span class="title" v-html="info.label"></span>
                  <br />
                  <span class="total" :style="{ color: info.color }">
                    <div
                      v-if="info.label == 'Total Financed'"
                      v-html="$utils.formatMoney(info.count, defaultCurrency)"
                    />
                    <div v-else v-html="info.count" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body col-md-12 col-lg-12 col-xl-12">
            <table-component
              v-if="updateLoginHistory && isLoaded"
              :show-filter="false"
              :data="loginData"
              table-class="table"
            >
              <table-column
                :label="$t('login_info.date')"
                sort-as="created_at"
                show="formattedCreatedAt"
              />
              <table-column
                :label="$t('login_info.login_time')"
                show="formattedCreatedAtDetail"
              />
              <table-column
                :label="$t('login_info.login_detail')"
                show="loginDetail"
              />
            </table-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import SuperAdminPanelInfoChart from "../../components/chartjs/SuperAdminPanelInfoChart";
import BarChart from "../../components/chartjs/BarChart";
export default {
  components: {
    SuperAdminPanelInfoChart,
    BarChart
  },
  data() {
    return {
      showFilters: false,
      filtersApplied: false,
      isRequestOngoing: true,
      isLoaded: false,
      filters: {
        to_date: "",
        from_date: "",
        account_id: "",
        select_activity: ""
      },
      selected_user_type: "Super Admin",
      chart_user_type: null,
      chartData: {
        info: [],
        labels: [],
        values: [],
        colors: []
      },
      updateLoginHistory: false,
      updateChart: false,
      accountOption: [],
      selectedAccount: null,
      from_date: null,
      to_date: null,
      selectedActivity: null,
      activityOption: [
        "Accounts",
        "Invoices",
        "Purchase Orders",
        "Payments",
        "Login History",
        "Need Actions"
      ],
      loginHistory: []
    };
  },
  computed: {
    ...mapGetters("currency", ["defaultCurrency"]),
    ...mapGetters("superAdminDashboard", []),
    showEmptyScreen() {
      return !this.isRequestOngoing && !this.filtersApplied;
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    },
    selectedAccount(val) {
      if (val) {
        this.updateChart = false;
        this.selected_user_type = val.UpperCaseAccountType;
        this.filters.account_id = val.id;
      }
    },
    from_date(val) {
      if (val) {
        this.updateChart = false;
        this.filters.from_date = val;
      }
    },
    to_date(val) {
      if (val) {
        this.updateChart = false;
        this.filters.to_date = val;
      }
    },
    selectedActivity(val) {
      if (val) {
        this.updateLoginHistory = false;
        this.updateChart = false;
        this.filters.select_activity = val;
      }
    }
  },
  created() {
    this.getAccount();
    this.loadData();
  },
  methods: {
    ...mapActions("superAdminDashboard", ["panelInformation"]),
    ...mapActions("account", ["fetchAccounts"]),
    async getAccount() {
      let data = { pagination: "no", role: "admin" };
      let response = await this.fetchAccounts(data);
      this.accountOption = [
        {
          label: "Supplier",
          isDisable: true,
          options: response.data.accounts.data.filter(account => {
            return account.UpperCaseAccountType === "SUPPLIER";
          })
        },
        {
          label: "Anchor",
          isDisable: true,
          options: response.data.accounts.data.filter(account => {
            return account.UpperCaseAccountType === "ANCHOR";
          })
        },
        {
          label: "Funder",
          isDisable: true,
          options: response.data.accounts.data.filter(account => {
            return account.UpperCaseAccountType === "FUNDER";
          })
        }
      ];
    },
    async loadData() {
      let params = {
        account_id: this.filters.account_id,
        activity: this.filters.select_activity,
        from_date:
          this.filters.from_date === ""
            ? this.filters.from_date
            : moment(this.filters.from_date).format("DD/MM/YYYY"),
        to_date:
          this.filters.to_date === ""
            ? this.filters.to_date
            : moment(this.filters.to_date).format("DD/MM/YYYY")
      };
      this.isLoaded = false;

      let response = await this.panelInformation(params);

      if (response.data) {
        this.isLoaded = true;
        if (response.data.chartData) {
          this.chartData.info = response.data.chartData;
          this.chartData.values = response.data.chartData.map(obj => obj.count);
          this.chartData.labels = response.data.chartData.map(obj => obj.label);
          this.chartData.colors = response.data.chartData.map(obj => obj.color);
          if (this.filters.select_activity) {
            this.chartData.values.splice(this.chartData.values.length - 1);
            this.chartData.labels.splice(this.chartData.labels.length - 1);
            this.chartData.colors.splice(this.chartData.colors.length - 1);
          } else {
            this.chartData.values.splice(this.chartData.values.length - 2);
            this.chartData.labels.splice(this.chartData.labels.length - 2);
            this.chartData.colors.splice(this.chartData.colors.length - 2);
          }

          this.updateChart = true;
        } else if (response.data.loginHistory) {
          this.loginHistory = response.data.loginHistory;
          this.updateLoginHistory = true;
        }
        if (this.selected_user_type == "SUPPLIER") {
          this.activityOption = [
            "Customers",
            "Invoices",
            "Purchase Orders",
            "Payments",
            "Login History",
            "Need Actions"
          ];
        } else if (this.selected_user_type == "ANCHOR") {
          this.activityOption = [
            "Suppliers",
            "Invoices",
            "Purchase Orders",
            "Payments",
            "Login History",
            "Need Actions"
          ];
        } else if (this.selected_user_type == "FUNDER") {
          this.activityOption = [
            "Clients",
            "Invoices",
            "Payments",
            "Login History",
            "Need Actions"
          ];
        }
      }
    },
    async loginData({ page, per_page, filter, sort }) {
      return {
        data: this.loginHistory.data,
        pagination: {
          totalPages: this.loginHistory.last_page,
          currentPage: page,
          rowsPerPage: per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshGraph();
    },
    clearFilter() {
      this.filters = {
        to_date: "",
        from_date: "",
        account_id: "",
        select_activity: ""
      };
      this.selectedAccount = null;
      this.selected_user_type = "Super Admin";
      this.selectedActivity = null;
      this.from_date = null;
      this.to_date = null;
      this.activityOption = [
        "Accounts",
        "Invoices",
        "Purchase Orders",
        "Payments"
      ];
      this.updateChart = false;

      this.$nextTick(() => {
        this.filtersApplied = false;
      });
    },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter();
        this.refreshGraph();
      }
      this.showFilters = !this.showFilters;
    },
    refreshGraph(val) {
      this.loadData();
    }
  }
};
</script>
